/* script */
//
//
//
//
//
//


// Components
import EventProgress from 'ui/components/modals/EventProgress.vue';

const EVENT_PROGRESS_MODAL_NAME = 'event-progress-modal';

/**
 * This component is the show progress modal for Restore event.
 *
 * @category ui.pages
 * @exports RestoreEvent
 */
const __vue_script__ = {
    name: 'RestoreEvent',

    components: { EventProgress },

    props: {
        title: {
            type: String,
            required: true
        },
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            showProgress: false,
            progress: 0,
        };
    },

    async created() {
        await this.restoreEvent();
    },

    methods: {

        /**
         * Restore Event function call
         *
         */
        async restoreEvent() {
            // template have id, workspace have _id
            const eventId = this.event._id || this.event.id;
            const node = this.$utils.workspaces.getRootNodeName(this.event);
            const jobResultUrl = this.$utils.url.getBackstageURL(node, this.$const.QUEUE_JOB_STATUS_PATH);
            const minutesToTimeout = 15;
            const interval = 1500;

            try {
                const { jobId, status, error } = await this.$services.event.restoreArchivedEvent(eventId, node);

                if (status === 'failed') {
                    return this.handleError({ error });
                }

                if (jobId) {
                    this.showProgress = true;

                    await this.$services.jobs.waitFor({
                        jobId: jobId,
                        statusPath: jobResultUrl,
                        resultPath: jobResultUrl,
                        updateUIProgress: this.updateProgress,
                        interval, minutesToTimeout
                    });

                    const eventUrl = this.$services.event.getEventUrl(this.event);

                    this.$router.redirect(eventUrl);
                } else {
                    this.$alert.show(
                        'events.archived.restore_in_progress_message',
                        null,
                        {
                            title: this.$i18n.t('events.archived.restore_in_progress_title'),
                            buttonClasses: ['default']
                        }
                    );
                }
            } catch (error) {
                this.handleError(error);
            } finally {
                this.closeProgressModal();
            }
        },

        /**
         * Updates the creation process progress.
         *
         * @param {Number} progress the current progress
         */
        updateProgress(progress) {
            this.progress = progress;
        },

        /**
         * Closes progress modal for restoring an event
         */
        closeProgressModal() {
            this.$modal.hide(EVENT_PROGRESS_MODAL_NAME);
        },

        /**
         * Handles error states
         *
         * @param {Object} error
         */
        handleError(error) {
            console.error('[EventsList] Could not restore workspace', error.message);
            this.$services.crashReporting.captureException(error);

            const errorMsg = (error || {}).error;

            this.$alert.show(
                errorMsg ? null : 'events.archived.restore_error',
                errorMsg,
                {
                    title: this.$i18n.t('general.something_wrong'),
                    buttonClasses: ['primary']
                }
            );
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showProgress)?_c('event-progress',{attrs:{"progress":_vm.progress,"title":_vm.title}}):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RestoreEvent.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__